module.exports = __webpack_public_path__ + "static/media/signage-outdoor-img7.e1481ebd.jpg";